'use client'

import styled from "styled-components";
import 'react-international-phone/style.css';
import {PhoneInput} from "react-international-phone";
import {getColor} from "@/pipes/theme.pipe";
import {getVariantStyles} from "@/components/UI/Form/Inputs/BaseInput/options/variant.options";


export const PhoneInputWrapper = styled.div`
    width: 100%;
    position: relative;
`

export const PhoneInputStyled = styled(PhoneInput)`
    background-color: ${getColor('natural', '600')};
    border-radius: 20px;
    
    .react-international-phone-country-selector-button {
        height: 40px;
        border: none;
    }
    .react-international-phone-country-selector {
        button {
            background-color: unset;
            position: absolute;
            z-index: 1;
            padding: 20px;
        }
        
        ul {
            ${getVariantStyles};
            border-radius: 10px;
            padding: 5px;
        }
    }
    
    .react-international-phone-input {
        width: 100%;
        ${getVariantStyles};
        border-radius: 20px;
        height: 40px;
        
        position: relative;
        padding-left: 50px;
        border-color: transparent;
        
        &:hover, &:active, &:focus, &:focus-within, &:focus-visible {
            border-color: ${getColor('secondary', '300')} !important;
        }
    }
`
